module.exports = __webpack_public_path__ + "static/banner-9e54c71e9919fd23cfae91d077b1decf.jpg";